import React from "react";


const Feature = (props) => {

   let formData =  props.kfsData ;
   
  return (
    <div>
      <h3 style={{ textAlign: "center" }}>Schedule II</h3>
      <p style={{ textAlign: "center", fontStyle: "italic" }}>Key Facts Statement</p>
      <p style={{ textAlign: "center" }}><b>Part 1 (Interest rate and fees/charges)</b></p>
      <table className="table">
        <tbody>
          <tr>
            <td style={{ width: "5%" }}>1</td>
            <td style={{ width: "25%" }}>Loan proposal/ account No.</td>
            <td style={{ width: "20%" }}>{formData?.loan_id}</td>
            <td style={{ width: "25%" }} colSpan="2">Type of Loan</td>
            <td style={{ width: "25%" }} colSpan="2">{formData?.loan_type}</td>
          </tr>
          <tr>
            <td style={{ width: "5%" }}>2</td>
            <td style={{ width: "45%" }} colSpan="2">Sanctioned Loan amount (in Rupees)</td>
            <td style={{ width: "50%" }} colSpan="4">{formData?.loan_amount}</td>
          </tr>
          <tr>
            <td style={{ width: "5%" }}>3</td>
            <td style={{ width: "45%" }} colSpan="2">Disbursal schedule
              <ol style={{ listStyleType: "lower-roman" }}>
                <li>Disbursement in stages or 100% upfront.</li>
                <li>If it is stage wise, mention the clause of loan agreement having relevant details</li>
              </ol>
            </td>
            <td colSpan="4">{formData?.disbursal_schedule}</td>
          </tr>
          <tr>
            <td>4</td>
            <td colSpan="2">Loan term (year/months/days)</td>
            <td colSpan="4">{formData?.loan_tenure}</td>
          </tr>
          <tr>
            <td>5</td>
            <td colSpan="6">Installment details</td>
          </tr>
          <tr>
            <td>Type of installments</td>
            <td>Number of EPIs</td>
            <td>EPI (Rs)</td>
            <td colSpan="4">Commencement of repayment, post sanction</td>
          </tr>
          <tr>
            <td>{formData?.repayment_frequency}</td>
            <td>{formData?.no_of_emi}</td>
            <td>{formData?.emi_amount}</td>
            <td colSpan="4">{formData?.emi_date}</td>
          </tr>
          <tr>
            <td>6</td>
            <td colSpan="2">Interest rate (%) and type (fixed or floating or hybrid)</td>
            <td colSpan="4">{formData?.interest_rate}</td>
          </tr>
          <tr>
            <td>7</td>
            <td colSpan="2">Additional Information in case of Floating rate of interest</td>
            <td colSpan="4">N/A</td>
          </tr>
          <tr>
            <td rowSpan="2">Reference Benchmark</td>
            <td rowSpan="2">Benchmark rate (%) (B)</td>
            <td rowSpan="2">Spread (%) (S) </td>
            <td colSpan="2">Final rate (%) R = (B) + (S)</td>
            <td>Reset periodicity (Months)</td>
            <td>Impact of change in the reference benchmark (for 25 bps change in ‘R’, change in:)</td>
          </tr>
          <tr>
            <td style={{ width: "5%" }}>B</td>
            <td style={{ width: "10%" }}>S</td>
            <td>EPI (Rs)</td>
            <td>No. of EPIs</td>
          </tr>
          <tr>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
          </tr>
          <tr>
            <td>8</td>
            <td colSpan="6">Fee/ Charges</td>
          </tr>
          <tr>
            <td colSpan="2"></td>
            <td colSpan="2">Payable to the RE (A)</td>
            <td colSpan="3">Payable to a third party through RE (B)</td>
          </tr>
          <tr>
            <td colSpan="1"></td>
            <td colSpan="1"></td>
            <td colSpan="1">One-time/ Recurring</td>
            <td colSpan="1">Amount (in Rs) or Percentage (%) as applicable</td>
            <td colSpan="2">One-time/Recurring</td>
            <td colSpan="1">Amount (in Rs) or Percentage (%) as applicable</td>
          </tr>
          <tr>
            <td>(i)</td>
            <td colSpan="1">Processing fees</td>
            <td colSpan="1">One Time</td>
            <td colSpan="1">{formData?.processing_fee}</td>
            <td colSpan="2">N/A</td>
            <td colSpan="1">N/A</td>
          </tr>
          <tr>
            <td>(ii)</td>
            <td colSpan="1">Insurance charges</td>
            <td colSpan="1">{formData?.insurance_charges}</td>
            <td colSpan="1">N/A</td>
            <td colSpan="2">N/A</td>
            <td colSpan="1">N/A</td>
          </tr>
          <tr>
            <td>(iii)</td>
            <td colSpan="1">Valuation fees</td>
            <td colSpan="1">{formData?.valuation_fees}</td>
            <td colSpan="1">N/A</td>
            <td colSpan="2">N/A</td>
            <td colSpan="1">N/A</td>
          </tr>
          <tr>
            <td>(iv)</td>
            <td colSpan="1">Any other (please specify)</td>
            <td colSpan="1">{formData?.other_charges}</td>
            <td colSpan="1">{formData?.platform_facilitation_fee}</td>
            <td colSpan="2">N/A</td>
            <td colSpan="1">N/A</td>
          </tr>
          <tr>
            <td>9</td>
            <td colSpan="2">Annual Percentage Rate (APR) (%)</td>
            <td colSpan="4">{formData?.APR}</td>
          </tr>
          <tr>
            <td>10</td>
            <td colSpan="6">Details of Contingent Charges (in Rs or %, as applicable)</td>
          </tr>
          <tr>
            <td>(i)</td>
            <td colSpan="2">Penal charges, if any, in case of delayed payment</td>
            <td colSpan="4">{formData?.penal_charges}</td>
          </tr>
          <tr>
            <td>(ii)</td>
            <td colSpan="2">Other penal charges, if any</td>
            <td colSpan="4">{formData?.other_penal_charges}</td>
          </tr>
          <tr>
            <td>(iii)</td>
            <td colSpan="2">Foreclosure charges, if applicable</td>
            <td colSpan="4">{formData?.foreclosure_charges}</td>
          </tr>
          <tr>
            <td>(iv)</td>
            <td colSpan="2">Charges for switching of loans from floating to fixed rate and vice versa</td>
            <td colSpan="4">{formData?.charges_for_switching}</td>
          </tr>
          <tr>
            <td>(v)</td>
            <td colSpan="2">Any other charges (please specify)</td>
            <td colSpan="4">{formData?.other_charges_specify}</td>
          </tr>
        </tbody>
      </table>

      <p style={{ textAlign: "center" }}><b>Part 2 (Other qualitative information)</b></p>
      <table className="table">
        <tbody>
          <tr>
            <td style={{ width: "5%" }}>1.</td>
            <td colSpan="2">Clause of Loan agreement relating to engagement of recovery agent</td>
            <td>Clause 6.1</td>
          </tr>
          <tr>
            <td>2.</td>
            <td colSpan="2">Clause of Loan agreement which details grievance redressal mechanism</td>
            <td>Clause 6.7</td>
          </tr>
          <tr>
            <td>3.</td>
            <td colSpan="2">Phone number and email id of the nodal grievance redressal officer</td>
            <td>support@alphamoney.in<br />+91-9319689801</td>
          </tr>
          <tr>
            <td>4.</td>
            <td colSpan="2">Phone number and email id of the senior grievance redressal officer</td>
            <td>support@alphamoney.in<br />+91-9319689801</td>
          </tr>
          <tr>
            <td>5.</td>
            <td colSpan="2">Website link of the lender</td>
            <td>www.alphamoney.in</td>
          </tr>
          <tr>
            <td>6.</td>
            <td colSpan="2">Whether loan is secured or unsecured?</td>
            <td>Secured</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Feature;
